import Label from "common/components/ui/Label";
import RadioButton from "common/components/ui/RadioButton";
import { SUBSCRIPTION_STATUSES } from "common/constants";
import { typedObjectEntries } from "common/helpers/utils";
import useAppStore from "common/hooks/useAppStore";

export default function SubscriptionStatus() {
  const subscriptionStatus = useAppStore(
    (state) => state.debugOptions.subscriptionStatus,
  );
  const isWithoutSubscription = useAppStore(
    (state) => state.debugOptions.isWithoutSubscription,
  );
  return (
    <>
      <span className="my-2 text-xs text-black-400">Subscription Status</span>
      <div className="flex flex-wrap gap-2">
        <div className="flex gap-x-1">
          <RadioButton
            size="sm"
            id="defaultSubscription"
            onChange={() =>
              useAppStore
                .getState()
                .setDebugOptions({ subscriptionStatus: null })
            }
            name="subscriptionStatus"
            checked={!subscriptionStatus}
          />
          <Label htmlFor="defaultSubscription" size="sm">
            Default
          </Label>
        </div>
        {typedObjectEntries(SUBSCRIPTION_STATUSES).map(([key, status]) => {
          const id = `subscription-${key}`;

          return (
            <div className="flex gap-x-1" key={id}>
              <RadioButton
                size="sm"
                id={id}
                disabled={isWithoutSubscription}
                onChange={() =>
                  useAppStore
                    .getState()
                    .setDebugOptions({ subscriptionStatus: key })
                }
                name="subscriptionStatus"
                checked={subscriptionStatus === key}
              />
              <Label htmlFor={id} size="sm">
                {status}
              </Label>
            </div>
          );
        })}
      </div>
    </>
  );
}
